import { render, staticRenderFns } from "./filterDetails.vue?vue&type=template&id=cb70bdd8"
import script from "./filterDetails.vue?vue&type=script&lang=js"
export * from "./filterDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports